import { CalendarPeriod } from '@liks/lac-svc-api/esm/models/index';
import { useCostChartRange } from '../../costs/useCostChartRange';
import { dayToIsoRange, monthToIsoRange } from '../../../utils/dateTimeUtils';
import { useLacCrawlJobAnalyticsQuery } from '../queries/useLacCrawlJobAnalyticsQuery';
import { useLacCrawlJobTimeSeriesQuery } from '../queries/useLacCrawlJobTimeSeriesQuery';
import { LacCrawlJobAnalyticsSummary } from './LacCrawlJobAnalyticsSummary';
import { LacCrawlJobTimeSeriesChart } from './LacCrawlJobTimeSeriesChart';

export type LacTenantCrawlJobTimeSeriesChartProps = {
  tenantName: string;
  enabled?: boolean;
};

export function LacTenantCrawlJobTimeSeriesChart({
  tenantName,
  enabled = true,
}: LacTenantCrawlJobTimeSeriesChartProps) {
  const range = useCostChartRange();
  const dailyIsoRange = dayToIsoRange(range.fromDay, range.toDay);
  const monthlyIsoRange = monthToIsoRange(range.fromMonth, range.toMonth);
  const activeIsoRange =
    range.mode === 'daily' ? dailyIsoRange : monthlyIsoRange;

  const dailyQuery = useLacCrawlJobTimeSeriesQuery({
    tenantName,
    groupBy: CalendarPeriod.Day,
    fromDate: dailyIsoRange.fromDate,
    toDate: dailyIsoRange.toDate,
    enabled: enabled && range.mode === 'daily',
  });
  const monthlyQuery = useLacCrawlJobTimeSeriesQuery({
    tenantName,
    groupBy: CalendarPeriod.Month,
    fromDate: monthlyIsoRange.fromDate,
    toDate: monthlyIsoRange.toDate,
    enabled: enabled && range.mode === 'monthly',
  });

  const analyticsQuery = useLacCrawlJobAnalyticsQuery({
    tenantName,
    fromDate: activeIsoRange.fromDate,
    toDate: activeIsoRange.toDate,
    enabled,
  });

  const activeQuery = range.mode === 'daily' ? dailyQuery : monthlyQuery;

  return (
    <LacCrawlJobTimeSeriesChart
      mode={range.mode}
      onModeChange={range.setMode}
      fromDay={range.fromDay}
      toDay={range.toDay}
      fromMonth={range.fromMonth}
      toMonth={range.toMonth}
      rangeLabel={range.rangeLabel}
      canGoNext={range.canGoNext}
      onPrev={range.goPrev}
      onNext={range.goNext}
      query={activeQuery}
      aside={<LacCrawlJobAnalyticsSummary query={analyticsQuery} />}
    />
  );
}
